import { smoothScroll } from '@gn-audio/ui/tools/smooth-srcoll';
import { element } from 'angular';
import { domUtils } from './utilities/dom-utils';
var defaultScrollToOffset = 60;
var centerModeMultiplier = 2;
export var ScrollToDirective = [
    function () {
        return {
            link: function (_$scope, $element, _$attributes) {
                var $attributes = _$attributes;
                $element.on('click', function (event) {
                    var targetElement = domUtils.getElement($attributes.scrollTo);
                    if (!targetElement) {
                        return false;
                    }
                    var targetElementHeight = element(targetElement)
                        .outerHeight();
                    var availableHeight = document.documentElement.clientHeight;
                    var scrollOffset = $attributes.scrollToOffset === '' || isNaN(Number($attributes.scrollToOffset))
                        ? defaultScrollToOffset
                        : Number($attributes.scrollToOffset);
                    var offset = 0;
                    event.preventDefault();
                    if ($attributes.scrollToPosition === 'center' && targetElementHeight < availableHeight) {
                        offset = (availableHeight - targetElementHeight) / centerModeMultiplier;
                    }
                    smoothScroll(targetElement, { offset: (offset || 0) + scrollOffset });
                    return false;
                });
            },
            restrict: 'A',
        };
    },
];
